import _ from "lodash";

import { FileKindsState } from "./slice";

export const canFetchFileKinds = (state: FileKindsState) => !state.request.active;

export const getFileKindNames = (state: FileKindsState) => state.fileKinds;
